import React from "react";
import "./Header.scss";

import * as img from "assets/images/index";

type Props = {};

const Header: React.FC<Props> = () => {
  return (
    <div className="Header">
      <a href="https://nateonweb.nate.com">
        <img
          src={img.logo}
          alt="pc-logo"
          className="only-pc"
          width="170"
          height="33"
        />
      </a>
    </div>
  );
};

export default React.memo(Header);
